import { useEffect } from "react";
import { PublicShell } from "../components/PublicShell";
import TaperTool from "./TaperTool";

export default function PublicTaper() {
  useEffect(() => {
    document.title = "Free Benzodiazepine Taper Tool | TaperPath";
    let el = document.querySelector('meta[name="description"]');
    if (!el) { el = document.createElement("meta"); el.setAttribute("name", "description"); document.head.appendChild(el); }
    el.setAttribute("content", "A free benzodiazepine taper reference tool based on Ashton Manual principles — see diazepam equivalents and a gentle reduction schedule to discuss with your GP.");
    return () => { document.title = "TaperPath"; };
  }, []);
  return (
    <PublicShell>
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        <TaperTool />
      </div>
    </PublicShell>
  );
}
